import React, { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  position?: string;
};
function ContextSelectorMenu({ children, position = 'left' }: Props) {
  const positionClass = position === 'left' ? 'right-0' : 'left-0';
  return (
    <div className={`absolute top-full mt-1 z-100 ${positionClass}`} data-test-id="context-selector-menu">
      <div className="bg-white rounded border border-light shadow-lg">{children}</div>
    </div>
  );
}

export { ContextSelectorMenu };
